import { Controller } from "@hotwired/stimulus"

// data-controller="payment-type"
export default class extends Controller {
    static targets = ["select", "companyWrapper", "termsWrapper", "termsCheckbox", "submitButton"]

    connect() {
        this.toggle()
    }

    toggle() {
        const isPersonal = this.selectTarget.value === "true" // физ. лицо

        if (isPersonal) {
            this.companyWrapperTarget.classList.add("d-none")
            this.termsWrapperTarget.classList.remove("d-none")
        } else {
            this.companyWrapperTarget.classList.remove("d-none")
            this.termsWrapperTarget.classList.add("d-none")
        }

        this.validateSubmit()
    }

    validateSubmit() {
        const isPersonal = this.selectTarget.value === "true" // физ. лицо

        if (isPersonal) {
            // Для физ. лица - нужно принять условия
            this.submitButtonTarget.disabled = !this.termsCheckboxTarget.checked
        } else {
            // Для юр. лица - кнопка всегда активна
            this.submitButtonTarget.disabled = false
        }
    }
}